module.exports = __webpack_public_path__ + "static/media/hs_20.2d33a1cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_20.jpg
// module id = 5951
// module chunks = 0